import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

const LoadingSpinner = ({ className, size = 'md', fullScreen = false }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  const spinner = (
    <div className={cn('flex items-center justify-center gap-3', className)}>
      <Loader2
        className={cn(sizeClasses[size], 'animate-spin text-blue-500')}
        strokeWidth={2}
      />
      <span className="text-sm text-slate-500 animate-pulse">불러오는 중...</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
        {spinner}
      </div>
    );
  }

  return <div className="p-8">{spinner}</div>;
};

export default LoadingSpinner;
